import { useEffect, useState } from 'react';
import { logError } from '../../features/shared/error/logError';

export function useGetApiData<T>(url: string) {
	const [data, setData] = useState<T | null>(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<Error | null>(null);

	const fetchData = async () => {
		try {
			setLoading(true);
			const response = await fetch(url, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					'Api-Key': `${process.env.DAP_API_KEY}`,
					'Api-Version': '100',
				},
			});

			if (!response.ok) {
				throw new Error('Network response was not ok');
			}

			const result = await response.json();
			setData(result);
		} catch (e) {
			if (e instanceof Error) {
				setError(e);
				logError(e);
			}
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchData();
	}, [url]);

	return { data, loading, error, refetch: fetchData };
}

export default useGetApiData;
